var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReadLaterGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 10.625C11.1287 10.625 10.625 11.1287 10.625 11.75V29.75C10.625 30.3713 11.1287 30.875 11.75 30.875H28.25C28.8713 30.875 29.375 30.3713 29.375 29.75V23C29.375 22.3787 29.8787 21.875 30.5 21.875C31.1213 21.875 31.625 22.3787 31.625 23V29.75C31.625 31.614 30.114 33.125 28.25 33.125H11.75C9.88604 33.125 8.375 31.614 8.375 29.75V11.75C8.375 9.88604 9.88604 8.375 11.75 8.375H18.5C19.1213 8.375 19.625 8.87868 19.625 9.5C19.625 10.1213 19.1213 10.625 18.5 10.625H11.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 8C21.5 7.17157 22.1716 6.5 23 6.5H32C32.8284 6.5 33.5 7.17157 33.5 8V19.28C33.5 20.1947 32.4558 20.7168 31.724 20.168L28.4 17.675C27.8667 17.275 27.1333 17.275 26.6 17.675L23.276 20.168C22.5442 20.7168 21.5 20.1947 21.5 19.28V8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.875 14C12.875 13.3787 13.3787 12.875 14 12.875H17.75C18.3713 12.875 18.875 13.3787 18.875 14C18.875 14.6213 18.3713 15.125 17.75 15.125H14C13.3787 15.125 12.875 14.6213 12.875 14Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.875 18.5C12.875 17.8787 13.3787 17.375 14 17.375H15.5C16.1213 17.375 16.625 17.8787 16.625 18.5C16.625 19.1213 16.1213 19.625 15.5 19.625H14C13.3787 19.625 12.875 19.1213 12.875 18.5Z",
    fill: "white"
  })));
}

export default SvgReadLaterGlyph;